// extracted by mini-css-extract-plugin
export default {"container":"EmptyList_container__fkz5J","containerImg":"EmptyList_containerImg__ovTHu","description":"EmptyList_description__QyxDY"};